import { render, staticRenderFns } from "./PackageAndTagIcon.vue?vue&type=template&id=7ee8c144"
import script from "./PackageAndTagIcon.vue?vue&type=script&lang=js"
export * from "./PackageAndTagIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports